export const getCurrentLocale = () => {

    const locales = [{code: 'PT', locale: 'pt-br'}, {code: 'DE', locale: 'de-de'},{code: 'ES', locale:  'es-mx'}, {code: 'US', locale: 'en-us'}, {code: 'FR', locale: 'fr-fr'}]
const currentLocale =  locales?.find(f => f.code === global.code)?.locale

return currentLocale;
}